import { fetch } from "@assets/js/imaios-global/imaios-global";

document.addEventListener("DOMContentLoaded", function() {
    if (null !== document.querySelector('form#shopuser')) {
        const registerSubmit = document.getElementById("registerFormSubmit");
        const paymentSubmit = document.getElementById("paymentFormSubmit");
        const communicationCheckbox = document.getElementById('register_opt');
        const mandatoryCheckbox = document.querySelectorAll('.mandatory-checkbox');

        // prevent submit button from been disabled if the checkbox is checked on load (if the user has refreshed the page)
        mandatoryCheckbox.forEach(function(child) {
            if (!child.checked) {
                registerSubmit.disabled = true;
            }
            child.onchange = function () {
                registerSubmit.disabled = true;
                if (child.checked) {
                    if (!checkFieldsEmptyFirstForm() && !checkMandatoryCheckboxEmpty()) {
                       registerSubmit.disabled = false;
                    }
                }
            }
        });


        window.myform = new ImaiosForm({
            element: 'shopuser',
            onsubmit: async imaiosForm => {
                imaiosForm.lockSubmit();

                await fetch(imaiosForm.form.action, imaiosForm.form.options).then(
                    response => {
                        const parser = new URL(window.location);
                        if (response.status === 400) {
                            response.text().then(data => {
                                document.getElementById('shopuser-result').innerHTML = data;
                                document.getElementById('shopuser-result').scrollIntoView();

                            });
                        } else if (response.status === 200) {
                            /* add analytics event add_shipping_info */
                            const analyticsItem = document.querySelector('div.begin-checkout');
                            if (analyticsItem !== null) {
                                imaios.pubsub.publish('analytics-add-shipping-info', {
                                    currency: analyticsItem.getAttribute('data-analytics-param-currency'),
                                    value: analyticsItem.getAttribute('data-analytics-param-value')
                                });
                            }
                            parser.searchParams.set('step', '2');
                            parser.searchParams.set('licence', true);
                            if (communicationCheckbox.checked === true) {
                                parser.searchParams.set('communication', true);
                            }
                            window.imaios.pubsub.publish('is-requiring-refresh-user-info');
                            window.location = parser.href;
                        }
                    },
                    error => {
                        console.log(error.message)
                    }
                )
            }
        });

        const urlParams = new URLSearchParams(window.location.search);
        const step = urlParams.get('step');

        if (step === '2') {
            toggleForm();
        }  else {
            Array
              .from(document.querySelectorAll('.register-form input[required="required"]'))
              .forEach(input => input.addEventListener('keyup', () => {
                  registerSubmit.disabled = (checkMandatoryCheckboxEmpty() || checkFieldsEmptyFirstForm());
              }))
        }

        function checkMandatoryCheckboxEmpty() {
            let i = 0;
            mandatoryCheckbox.forEach(function (child) {
                if (child.checked === true) { i++; }
            });
            return i < mandatoryCheckbox.length;
        }
        function checkFieldsEmptyFirstForm() {
            const firstForm = document.querySelector('.register-form');
            const inputs = firstForm.querySelectorAll('input[required="required"]');
            for (let i = 0, len = inputs.length; i < len; i++) {
                if (inputs[i].value.length === 0) { return true; }
            }
            return false;
        }

        function toggleForm() {
            document.getElementById('form-folded').classList.toggle('d-none');
            document.getElementById('form-unfolded').classList.toggle('d-none');
        }
    }
});
